// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ------------------------------------------------------------------------
 * @author      CEBS Worldwide
 * @copyright   � 2025 CEBS Worldwide. All rights reserved.
 * @license     STRICTLY CONFIDENTIAL
 * ------------------------------------------------------------------------ */

.audit-logs-container {
  padding: 1.5rem;
  background-color: #f4f7fc;
  min-height: 100vh;
  flex-grow: 1;
}

.audit-header {
  margin-bottom: 1.5rem;
  font-size: 1.4rem;
  font-weight: 600;
  color: #222;
}

.audit-table {
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  overflow: hidden;
}

.audit-table th,
.audit-table td {
  padding: 0.75rem 1rem;
  text-align: left;
  font-size: 0.95rem;
  border-bottom: 1px solid #e0e0e0;
}

.audit-table th {
  background-color: #0066cc;
  color: white;
  font-weight: 600;
}

.audit-table tbody tr:hover {
  background-color: #f0f5ff;
}

.audit-table td.time {
  color: #555;
  font-family: monospace;
}

.audit-badge {
  display: inline-block;
  padding: 0.25rem 0.6rem;
  font-size: 0.8rem;
  border-radius: 12px;
  background-color: #ddeaff;
  color: #004b99;
  font-weight: 500;
}

@media screen and (max-width: 768px) {
  .audit-table thead {
    display: none;
  }

  .audit-table, .audit-table tbody, .audit-table tr, .audit-table td {
    display: block;
    width: 100%;
  }

  .audit-table tr {
    margin-bottom: 1rem;
    border: 1px solid #ddd;
    border-radius: 8px;
    padding: 0.5rem;
  }

  .audit-table td {
    padding: 0.5rem 0.8rem;
    text-align: right;
    position: relative;
  }

  .audit-table td::before {
    content: attr(data-label);
    position: absolute;
    left: 0.8rem;
    text-align: left;
    font-weight: bold;
    color: #333;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/demo/audit/AuditLogs.css"],"names":[],"mappings":"AAAA;;;;6EAI6E;;AAE7E;EACE,eAAe;EACf,yBAAyB;EACzB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,uBAAuB;EACvB,yCAAyC;EACzC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;;EAEE,qBAAqB;EACrB,gBAAgB;EAChB,kBAAkB;EAClB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,sBAAsB;IACtB,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,iBAAiB;IACjB,kBAAkB;EACpB;;EAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;EACb;AACF","sourcesContent":["/* ------------------------------------------------------------------------\n * @author      CEBS Worldwide\n * @copyright   � 2025 CEBS Worldwide. All rights reserved.\n * @license     STRICTLY CONFIDENTIAL\n * ------------------------------------------------------------------------ */\n\n.audit-logs-container {\n  padding: 1.5rem;\n  background-color: #f4f7fc;\n  min-height: 100vh;\n  flex-grow: 1;\n}\n\n.audit-header {\n  margin-bottom: 1.5rem;\n  font-size: 1.4rem;\n  font-weight: 600;\n  color: #222;\n}\n\n.audit-table {\n  width: 100%;\n  border-collapse: collapse;\n  background-color: white;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.audit-table th,\n.audit-table td {\n  padding: 0.75rem 1rem;\n  text-align: left;\n  font-size: 0.95rem;\n  border-bottom: 1px solid #e0e0e0;\n}\n\n.audit-table th {\n  background-color: #0066cc;\n  color: white;\n  font-weight: 600;\n}\n\n.audit-table tbody tr:hover {\n  background-color: #f0f5ff;\n}\n\n.audit-table td.time {\n  color: #555;\n  font-family: monospace;\n}\n\n.audit-badge {\n  display: inline-block;\n  padding: 0.25rem 0.6rem;\n  font-size: 0.8rem;\n  border-radius: 12px;\n  background-color: #ddeaff;\n  color: #004b99;\n  font-weight: 500;\n}\n\n@media screen and (max-width: 768px) {\n  .audit-table thead {\n    display: none;\n  }\n\n  .audit-table, .audit-table tbody, .audit-table tr, .audit-table td {\n    display: block;\n    width: 100%;\n  }\n\n  .audit-table tr {\n    margin-bottom: 1rem;\n    border: 1px solid #ddd;\n    border-radius: 8px;\n    padding: 0.5rem;\n  }\n\n  .audit-table td {\n    padding: 0.5rem 0.8rem;\n    text-align: right;\n    position: relative;\n  }\n\n  .audit-table td::before {\n    content: attr(data-label);\n    position: absolute;\n    left: 0.8rem;\n    text-align: left;\n    font-weight: bold;\n    color: #333;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
